
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    LazyImg
  }
})
export default class HowXt extends Vue {
  status: 'init' | 'playing' | 'pause' = 'init'

  @Ref()
  howXtVideo: {
    handlePlay: () => void
  } | null

  get options() {
    return {
      video: {
        url: `${this.$store.$global.static}/video/tenth-yearv4.mp4`,
        pic: 'https://file.xuantong.cn/images/origin/f1e2ffc4bc57f27415bc3972924d7d86.jpg'
      },
      screenshot: false,
      lang: 'zh-cn',
      autoplay: false
    }
  }

  onPlaying() {
    this.status = 'playing'
  }

  onPause() {
    this.status = 'pause'
  }

  startPlay() {
    if (!this.howXtVideo) return

    this.howXtVideo.handlePlay()
    this.status = 'playing'
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
